<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="秒杀商品名称">
                <el-input  v-model="queryForm.productName"></el-input>
            </el-form-item>
            <!--el-form-item label="秒杀商品价格">
                <el-input  v-model="queryForm.seckillPrice"></el-input>
            </el-form-item>
            <el-form-item label="秒杀数量">
                <el-input  v-model="queryForm.seckillSize"></el-input>
            </el-form-item-->
            <el-form-item label="开始时间">
                <el-input  v-model="queryForm.startTime"></el-input>
            </el-form-item>
            <el-form-item label="束结时间">
                <el-input  v-model="queryForm.endTime"></el-input>
            </el-form-item>
            <!--el-form-item label="单次最大限购数量">
                <el-input  v-model="queryForm.buyMaxLimit"></el-input>
            </el-form-item>
            <el-form-item label="总限购数量">
                <el-input  v-model="queryForm.buyLimit"></el-input>
            </el-form-item-->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopProductSeckillList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopProductSeckill"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopProductSeckill(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopProductSeckill(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
					
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
					  <Icon color="#606266">
						<Search />
					  </Icon>
					</span>
					
                    <!--span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
					  <Icon color="#606266">
						<ArrowDown />
					  </Icon>
					</span>
					
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
					  <Icon color="#606266">
						<ArrowExportUp24Regular />
					  </Icon>
					</span>
					
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportShopProductSeckillList"
                    >
					  <Icon color="#606266">
						<ArrowDownload24Regular />
					  </Icon>
					</span-->
					
                    <span
                        class="icon-box"
                        @click="refreshShopProductSeckillList"
                    >
					  <Icon color="#606266">
						<Refresh />
					  </Icon>
					</span>
					
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopProductSeckillList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="productName"
                    label="秒杀商品名称"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="productPic"
                    label="秒杀商品图片"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.productPic'>
                            <el-image @click='updateSrcList(scope.row.productPic)' style="width: 60px; height: 60px"
                                      :src="scope.row.productPic" :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>--</div>
                    </template></el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="productAlbum"-->
<!--                    label="秒杀商品相册"-->
<!--                    width="180"-->
<!--                > </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="seckillPrice"
                    label="秒杀商品价格"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="seckillStock"
                    label="秒杀库存"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="seckillSize"
                    label="秒杀数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="startTime"
                    label="开始时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="endTime"
                    label="束结时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="buyMaxLimit"
                    label="单次最大限购数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="buyLimit"
                    label="总限购数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopProductSeckill(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopProductSeckill(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopProductSeckill(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopProductSeckillStates[shopProductSeckillState]"
                :visible.sync="showDialog"
                width="600px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopProductSeckill"
                        ref="shopProductSeckillForm"
                        :rules="rules"
                        label-width="140px"
                        size="small"
                    >
                        <el-form-item
                            label="秒杀商品图片"
                            prop="productPic"
                            style="margin-left: 50px"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 250px"-->
<!--                                v-model="shopProductSeckill.productId"-->
<!--                                :disabled="shopProductSeckillState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectLi :disabled="shopProductSeckillState == 'check'" style="width: 186px" title="选择商品" labelName="productPic"
                                      labelValue="id" :value="shopProductSeckill.productId" :limit="1" size="small" placeholder="请选择商品"
                                      @getValue="getSeachValuebrandId" @getPrice="getPrice" :columns="PRODUCT_code" :searchs="PRODUCT_search" dataListUrl="/shop/product/findList" entityBeanName="shopProduct"
                                      queryEntityUrl="/shop/product/get">
                            </GridSelectLi>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="秒杀商品名称"-->
<!--                            prop="productName"-->
<!--                            style="margin-left: 50px"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 250px"-->
<!--                                v-model="shopProductSeckill.productName"-->
<!--                                :disabled="shopProductSeckillState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="秒杀商品名称"
                            prop="productName"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.productName"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="秒杀商品相册"
                            prop="productAlbum"
                            v-if="shopProductSeckill.productAlbum"
                            style="margin-left: 50px"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 250px"-->
<!--                                v-model="shopProductSeckill.productAlbum"-->
<!--                                :disabled="shopProductSeckillState == 'check'"-->
<!--                            ></el-input>-->
                            <div style="display: flex;flex-wrap: wrap">
                                <img v-for="item in srcProductList" style="margin-right:10px;margin-bottom: 10px;width: 70px;height: 70px;" :src="item" class="avatar" size="small" />
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="秒杀商品价格"
                            prop="seckillPrice"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.seckillPrice"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="秒杀库存"
                            prop="seckillStock"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.seckillStock"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="秒杀数量"
                            prop="seckillSize"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.seckillSize"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="开始/结束时间"
                            prop="startTime"
                            style="margin-left: 50px"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 250px"-->
<!--                                v-model="shopProductSeckill.startTime"-->
<!--                                :disabled="shopProductSeckillState == 'check'"-->
<!--                            ></el-input>-->
                            <el-date-picker
                                :disabled="shopProductSeckillState == 'check'"
                                v-model="value"
                                style="width: 250px;"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间">
                            </el-date-picker>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="束结时间"-->
<!--                            prop="endTime"-->
<!--                            style="margin-left: 50px"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 250px"-->
<!--                                v-model="shopProductSeckill.endTime"-->
<!--                                :disabled="shopProductSeckillState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="单次最大限购数量"
                            prop="buyMaxLimit"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.buyMaxLimit"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="总限购数量"
                            prop="buyLimit"
                            style="margin-left: 50px"
                        >
                            <el-input
                                size="small"
                                style="width: 250px"
                                v-model="shopProductSeckill.buyLimit"
                                :disabled="shopProductSeckillState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopProductSeckillState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectLi from '@/components/shop/selectProduct.vue';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductSeckillList();
                this.getShopProductSeckillList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductSeckillList();
                this.getShopProductSeckillList();
                this.$emit('resetCheckState');
            }
        },
        value:{
            handler(newvalue){
                if(newvalue == null){
                    this.shopProductSeckill.startTime = ""
                    this.shopProductSeckill.endTime = ""
                }else{
                    console.log(new Date())
                    let date = new Date(newvalue[0]);
                    this.shopProductSeckill.startTime = date.getFullYear() + "-" + this.pad(date.getMonth() + 1) + "-" + this.pad(date.getDate()) + " " + this.pad(date.getHours()) + ":" + this.pad(date.getMinutes()) + ":" + this.pad(date.getSeconds())
                    date = new Date(newvalue[1])
                    this.shopProductSeckill.endTime = date.getFullYear() + "-" + this.pad(date.getMonth() + 1) + "-" + this.pad(date.getDate()) + " " + this.pad(date.getHours()) + ":" + this.pad(date.getMinutes()) + ":" + this.pad(date.getSeconds())
                    console.log(this.shopProductSeckill)
                }
            },
            deep:true
        }
    },
    data() {
        return {
            PRODUCT_code: PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            queryForm:{
                productId: '', //商品ID
                productName: '', //秒杀商品名称
                productPic: '', //秒杀商品图片
                productAlbum: '', //秒杀商品相册
                seckillPrice: '', //秒杀商品价格
                seckillStock: '', //秒杀库存
                seckillSize: '', //秒杀数量
                startTime: '', //开始时间
                endTime: '', //束结时间
                buyMaxLimit: '', //单次最大限购数量
                buyLimit: '', //总限购数量
            },
            value: [],
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductSeckillState: 'add',
            shopProductSeckillStates: {
                add: '新建秒杀商品',
                check: '查看秒杀商品',
                edit: '修改秒杀商品'
            },
            srcList: [''],
            multipleSelection: [],
            shopProductSeckillList: [],
            shopProductSeckill: {
                id: '', //ID
                productId: '', //商品ID
                productName: '', //秒杀商品名称
                productPic: '', //秒杀商品图片
                productAlbum: '', //秒杀商品相册
                seckillPrice: '', //秒杀商品价格
                seckillStock: '', //秒杀库存
                seckillSize: '', //秒杀数量
                startTime: '', //开始时间
                endTime: '', //束结时间
                buyMaxLimit: '1', //单次最大限购数量
                buyLimit: 1, //总限购数量
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                productId: [{ required: true, message: '商品ID不能为空', trigger: 'blur' }],
                productName: [{ required: true, message: '秒杀商品名称不能为空', trigger: 'blur' }],
                productPic: [{ required: true, message: '秒杀商品图片不能为空', trigger: 'blur' }],
                productAlbum: [{ required: true, message: '秒杀商品相册不能为空', trigger: 'blur' }],
                seckillPrice: [{ required: true, message: '秒杀商品价格不能为空', trigger: 'blur' }],
                seckillStock: [{ required: true, message: '秒杀库存不能为空', trigger: 'blur' }],
                seckillSize: [{ required: true, message: '秒杀数量不能为空', trigger: 'blur' }],
                startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
                endTime: [{ required: true, message: '束结时间不能为空', trigger: 'blur' }],
                buyMaxLimit: [{ required: true, message: '单次最大限购数量不能为空', trigger: 'blur' }],
                buyLimit: [{ required: true, message: '总限购数量不能为空', trigger: 'blur' }],
            },
            srcProductList: [],
            productPrice: 0
        };
    },
    created() {
        this.getShopProductSeckillList();
    },
    methods: {
        getPrice(price){
            console.log(price)
            this.productPrice = price
        },
        search(){
            this.isSearch = !this.isSearch;
        },
        pad(num) {
            return num < 10 ? '0' + num : num;
        },
        // 搜索商品
        getSeachValuebrandId(value){
            console.log("?????")
            console.log(value)
            this.shopProductSeckill.productId = value.id
            this.shopProductSeckill.productName = value.productName
            this.shopProductSeckill.productPic = value.productPic
            this.shopProductSeckill.seckillStock = value.stockSize
            this.productPrice = value.shopPrice
            this.shopProductSeckill.productAlbum = value.productAlbum
            this.srcProductList = value.productAlbum.split('|')
            console.log(this.shopProductSeckill)
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },
        resetShopProductSeckillList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductSeckillList = [];
        },
        resetDialog() {
            this.shopProductSeckillState = 'add';
            this.showDialog = false;
            this.queryForm = {
                productId: '', //商品ID
                productName: '', //秒杀商品名称
                productPic: '', //秒杀商品图片
                productAlbum: '', //秒杀商品相册
                seckillPrice: '', //秒杀商品价格
                seckillStock: '', //秒杀库存
                seckillSize: '', //秒杀数量
                startTime: '', //开始时间
                endTime: '', //束结时间
                buyMaxLimit: '', //单次最大限购数量
                buyLimit: '', //总限购数量
            };
            this.getShopProductSeckillList();
        },
        closeDialog() {
            this.showDialog = false
            this.shopProductSeckill = {
                id: '', //ID
                productId: '', //商品ID
                productName: '', //秒杀商品名称
                productPic: '', //秒杀商品图片
                productAlbum: '', //秒杀商品相册
                seckillPrice: '', //秒杀商品价格
                seckillStock: '', //秒杀库存
                seckillSize: '', //秒杀数量
                startTime: '', //开始时间
                endTime: '', //束结时间
                buyMaxLimit: '', //单次最大限购数量
                buyLimit: 1, //总限购数量
            };
            this.value = []
            this.srcProductList = []
        },
        submitForm() {
            if (this.shopProductSeckillState == 'add') {
                this.$refs.shopProductSeckillForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/productseckill/add`,{ ...this.shopProductSeckill }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopProductSeckillList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopProductSeckillState == 'edit') {
                this.$refs.shopProductSeckillForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.shopProductSeckill.product;
                        post(`/shop/productseckill/edit`,{ ...this.shopProductSeckill }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductSeckillList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopProductSeckill() {
            this.showDialog = true;
            this.shopProductSeckillState = 'add';
        },
        checkShopProductSeckill(shopProductSeckillId) {
            console.log(shopProductSeckillId);
            this.currentShopProductSeckillId = shopProductSeckillId;

            this.getShopProductSeckillById();
            this.showDialog = true;
            this.shopProductSeckillState = 'check';
        },
        editShopProductSeckill(shopProductSeckillId) {
            console.log('shopProductSeckill', shopProductSeckillId);
            if (shopProductSeckillId) {
                this.currentShopProductSeckillId = shopProductSeckillId;
                this.getShopProductSeckillById();
            } else {
                this.shopProductSeckill = { ...this.shopProductSeckill, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductSeckillState = 'edit';
        },
        deleteShopProductSeckill(shopProductSeckillId) {
            let ids = '';
            if (shopProductSeckillId) {
                ids = shopProductSeckillId;
            } else {
                ids = this.multipleSelection.map((shopProductSeckill) => shopProductSeckill.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productseckill/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductSeckillList();
                            this.getShopProductSeckillList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductSeckillList() {
            this.resetShopProductSeckillList();
            this.getShopProductSeckillList();
        },
        getShopProductSeckillList(query = {}) {
            this.loading = true;
            get(`/shop/productseckill/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductSeckillList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopProductSeckillById() {
            get(`/shop/productseckill/get`,{ id: this.currentShopProductSeckillId }).then((res) =>{
                if(res.success){
                    this.shopProductSeckill = { ...this.shopProductSeckill, ...res.shopProductSeckill };
                    this.value = [this.shopProductSeckill.startTime,this.shopProductSeckill.endTime]
                    this.srcProductList = this.shopProductSeckill.productAlbum.split("|")
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopProductSeckillList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/productseckill/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/productseckill/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/productseckill/importData`,formData);
            this.refreshShopProductSeckillList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductSeckillList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductSeckillList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>